<script>
import BreadcrumbHowItWorks from "../howItWorks/breadcrumbHowItWorks.vue";
import HowItWorksContent from "../howItWorks/howItWorksContent.vue";
import FooterSection from "../package/footerSection.vue";
// import MobileAppDownload from "../package/mobileAppDownload.vue";
import HeaderSection from "../package/HeaderSection.vue";
import DrawerAside from "../package/DrawerAside.vue";
import propertyIconSet from "../package/propertyIconSet.vue";
import BreadcrumbTermsAndConditions from "./breadcrumbTermsAndConditions.vue";
import TermsAndConditionsContent from "./termsAndConditionsContent.vue";

export default {
  name: "termsAndConditionsLayout",
  components: {
    TermsAndConditionsContent,
    BreadcrumbTermsAndConditions,
    propertyIconSet,
    DrawerAside,
    HeaderSection,
    // MobileAppDownload,
    FooterSection,
    HowItWorksContent,
    BreadcrumbHowItWorks
  },
  data() {
    return {
      unfold: false,
      value1: true,
      theme: "dark",
      switchColor: "#2D2D2D"
    };
  },
  beforeUpdate() {
    document.title = "UNIFI Property: Terms and Conditions";
  },
  created() {
    document.title = "UNIFI Property: Terms and Conditions";
  },
  mounted() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    let color = this.value1 ? "#2D2D2D" : "#FFFFFF";
    document.documentElement.style.setProperty("--switch-color", color);
  },
  watch: {
    value1(newValue) {
      let color = newValue ? "#2D2D2D" : "#FFFFFF";
      document.documentElement.style.setProperty("--switch-color", color);
    }
  },
  methods: {
    spread() {
      this.unfold = true;
    },
    fold() {
      this.unfold = false;
    }
  }
};
</script>

<template>
  <el-container class="mainWrapper">
    <el-aside style="padding: 0;" width="0vw">
      <drawer-aside :unfold="unfold" @unfoldMethod="fold($event)" />
    </el-aside>
    <el-container>
      <header-section @spread="spread" />
      <el-main style="padding: 0; overflow: visible;">
        <breadcrumb-terms-and-conditions />
        <terms-and-conditions-content />
        <property-icon-set />
<!--        <mobile-app-download />-->
      </el-main>
      <el-footer style="padding: 0; height: 0">
        <footer-section />
      </el-footer>
    </el-container>
  </el-container>
</template>

<style scoped>
.mainWrapper {
  background-color: #2d2d2d;
}
</style>



// WEBPACK FOOTER //
// src/components/terms/termsAndConditionsLayout.vue